import { ComponentType, type PrimitiveResolverProps } from 'data-types-config';
import { computed } from 'vue';

import ButtonInteractive from '../components/arche/primitives/Interactives/ButtonInteractive';
import FakeInteractive from '../components/arche/primitives/Interactives/FakeInteractive';
import InputInteractive from '../components/arche/primitives/Interactives/InputInteractive';
import EmailDestination from '../components/arche/primitives/Navigations/EmailDestination';
import ExternalDestination from '../components/arche/primitives/Navigations/ExternalDestination';
import InternalDestination from '../components/arche/primitives/Navigations/InternalDestination';
import PhoneDestination from '../components/arche/primitives/Navigations/PhoneDestination';

import AnchorPattern from '../components/arche/primitives/Navigations/AnchorPattern';
import BreadcrumbPattern from '../components/arche/primitives/Navigations/BreadcrumbPattern';
import DynamicRouteDestination from '../components/arche/primitives/Navigations/DynamicRouteDestination';
import RedirectPattern from '../components/arche/primitives/Navigations/RedirectPattern';

export default function usePrimitiveResolver(
  props: Partial<PrimitiveResolverProps>,
) {
  const typesMap = {
    [ComponentType.Email]: EmailDestination,
    [ComponentType.External]: ExternalDestination,
    [ComponentType.Fake]: FakeInteractive,
    [ComponentType.Input]: InputInteractive,
    [ComponentType.Internal]: InternalDestination,
    [ComponentType.Telephone]: PhoneDestination,
    [ComponentType.Interactive]: ButtonInteractive,
    [ComponentType.Anchor]: AnchorPattern,
    [ComponentType.Breadcrumb]: BreadcrumbPattern,
    [ComponentType.DynamicRoute]: DynamicRouteDestination,
    [ComponentType.Redirect]: RedirectPattern,
    [ComponentType.Link]: InternalDestination, // Default to internal for generic destinations
  };

  const isType = computed(() => {
    const typeKey = props.componentType as ComponentType;
    return typesMap[typeKey] || InternalDestination;
  });

  return {
    isType,
  };
}
